import React from 'react'
import styles from './DailyWotd.module.css';

const DailyWotdHeader = () => {
  return (
    <div>
      <div className={styles.headerTitleContainer}>
        <h1 className={styles.headerTitle}>WELCOME TO</h1>
        <h1 className={styles.headerTitleBold}>WORKOUT OF THE DAY</h1>
      </div>
    <p className={styles.headerSubtitle}>Choose How You Move</p>
    
    </div>  )
}

export default DailyWotdHeader